export const ExternalLinkSlugs = {
    ArgoCDIntegrationDocs: "argo-cd-integration-docs",
    AnnotationsDocs: "argo-cd-annotations-docs",
    CliGenerateTokenDocs: "argo-cd-cli-generate-token",
};
